import getStore from '../store';
import CalendarTime from 'owa-calendar-time-host/lib/schema/CalendarTime';
import { ClientItemId } from 'owa-client-ids';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import EventScope from 'owa-service/lib/contract/EventScope';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import { action } from 'satcheljs/lib/legacy';
/**
 * Shows cancellation/forward/response notes editor
 */
export default action('openNotesEditor')(function openNotesEditor(
    id: ClientItemId,
    eventScope: EventScope,
    onSend: (
        eventScope: EventScope,
        responseText: string,
        responseType: ResponseTypeType,
        proposedTime: CalendarTime,
        sendResponse: boolean,
        forwardees: AttendeeType[],
        timeOpen: number
    ) => void,
    titleText?: string,
    iconName?: string,
    proposedTime?: CalendarTime,
    forwardees?: AttendeeType[],
    showNotifyToggle?: boolean,
    sendResponse?: boolean,
    isCancelledEvent?: boolean,
    isDeclinedSeriesInstance?: boolean,
    isTxpShareEvent?: boolean,
    responseType?: ResponseTypeType | 'Cancel'
) {
    // default showNotifyToggle to TRUE if not explicitly specified
    if (showNotifyToggle == undefined) {
        showNotifyToggle = true;
    }
    getStore().meetingIdToNotesViewStateMap.set(id.Id, {
        ...createEditorViewState(''),
        eventScope: eventScope,
        forwardees: forwardees,
        showNotifyToggle: showNotifyToggle,
        iconName: iconName,
        onSend: onSend,
        proposedTime: proposedTime,
        responseType: responseType,
        sendResponse: sendResponse,
        titleText: titleText,
        isCancelledEvent: isCancelledEvent,
        isDeclinedSeriesInstance: isDeclinedSeriesInstance,
        isTxpShareEvent: isTxpShareEvent,
        openTimeStamp: Date.now(),
    });
});
